module.exports = {
      id: "artsy-usage",
      viewBox: "0 0 652 652",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#artsy-usage",
      toString: function () {
        return this.url;
      }
    }